/**
 * Created by LordCheddar on 2019/02/21.
 */
class BlockvWrapper {

	/**
	 * Returns an instance of the BLOCKv SDK.
	 * 
	 * The instance is initialized with the current environment variables.
	 */
	get instance() {

		if (this.blockv == null) {
			const bv = require("../vendor/blockv-sdk.min.js");
			this.blockv = new bv({
				"appID": process.env.BLOCKV_APP_ID,
				"server": process.env.BLOCKV_API_URL,
				"websocketAddress": process.env.BLOCKV_API_WS_URL,
				"prefix": "blockv"
			});
			console.log(`Creating BLOCKv instance:
			${JSON.stringify(this.blockv.store, null, 2)}`);
		}

		return this.blockv;
	}
}

export default new BlockvWrapper()



// WEBPACK FOOTER //
// ./src/MainBv.js